/**
 * Требование к паролю — одной строкой на весь кабинет.
 *
 * Оно печаталось в пяти редакциях на четырёх экранах: «Не меньше 12 знаков»,
 * «Не меньше ${MIN_LENGTH} знаков. Лучше длинная фраза, чем короткая мешанина»,
 * «Не меньше двенадцати знаков. Верхней границы нет, менять по расписанию не
 * заставляем» — и число было написано и цифрой, и словом, и подстановкой.
 * Константа при этом лежала копией в трёх файлах, то есть первое же изменение
 * контракта развело бы экраны молча.
 *
 * `PASSWORD_HINT` — подсказка под полем, `shortPassword` — счётчик оставшихся
 * знаков. Число в счётчике не повторяется прописью: оно уже стоит в подсказке
 * над ним.
 */
import { countOf } from '@shared/src/format';

/** Контракт: не короче двенадцати знаков. Верхней границы нет. */
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_HINT = `Не меньше ${String(PASSWORD_MIN_LENGTH)} знаков. Лучше длинная фраза, чем короткая мешанина`;

/**
 * Сколько ещё знаков не хватает. `undefined` — либо поле пустое (человек ещё не
 * начал, и подгонять его нечем), либо длины уже достаточно.
 */
export function shortPassword(password: string): string | undefined {
  if (password.length === 0 || password.length >= PASSWORD_MIN_LENGTH) return undefined;
  const left = PASSWORD_MIN_LENGTH - password.length;
  return `Ещё ${countOf(left, 'знак', 'знака', 'знаков')}`;
}
